import { View } from "@react-pdf/renderer";
import {
  ResumePDFText,
  ResumePDFDescription,
} from "components/Resume/ResumePDF/common";
import { TemplateThreePDFSectionWithSubsections } from "./common";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import type { ResumeWorkExperience } from "lib/redux/types";

export const Experience = ({
  heading,
  workExperiences,
}: {
  heading: string;
  workExperiences: ResumeWorkExperience[];
}) => {
  return (
    <TemplateThreePDFSectionWithSubsections heading={heading}>
      {workExperiences.map(
        ({ company, jobTitle, startDate, endDate, descriptions }, idx) => {
          // Hide company name if it is the same as the previous company
          const hideCompanyName =
            idx > 0 && company === workExperiences[idx - 1].company;

          return (
            <View
              key={idx}
              style={{
                ...styles.flexRow,
                gap: "9pt", // Optimized spacing
                ...(idx !== 0 ? { marginTop: "9pt" } : {}),
              }}
              wrap={false} // Prevent individual experience items from splitting
            >
              <View style={{ width: "21%" }}>
                <ResumePDFText>
                  {startDate && endDate
                    ? `${startDate} - ${endDate}`
                    : startDate || endDate}
                </ResumePDFText>
              </View>
              <View style={{ width: "79%" }}>
                {!hideCompanyName && (
                  <ResumePDFText bold={true}>{company}</ResumePDFText>
                )}
                <View
                  style={{
                    ...styles.flexRowBetween,
                    marginTop: hideCompanyName
                      ? "-" + spacing["1"]
                      : spacing["1"], // Moderate reduction: 1.5 -> 1
                  }}
                >
                  <ResumePDFText>{jobTitle}</ResumePDFText>
                </View>
                <View style={{ ...styles.flexCol, marginTop: spacing["1"] }}> {/* Moderate reduction: 1.5 -> 1 */}
                  <ResumePDFDescription items={descriptions} />
                </View>
              </View>
            </View>
          );
        }
      )}
    </TemplateThreePDFSectionWithSubsections>
  );
};
